var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("base-tutorial", { attrs: { steps: _vm.steps } }, [
    _c("div", [
      _c("h2", [
        _vm._v(
          " Olá! Vamos observar o seu coeficiente de desempenho comportamental e técnico (nas perspectivas dos comportamentos e das responsabilidades) em conjunto? "
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v("Meu CDS")]),
      _c("p", [
        _vm._v(" Na aba "),
        _c("span", { staticClass: "info--text" }, [_vm._v("MEU CDS")]),
        _vm._v(
          " você visualiza seu posicionamento em uma matriz Comportamento X Responsabilidade, onde no eixo horizontal está o resultado final do desempenho comportamental (na perspectiva dos comportamentos) e no eixo vertical está o resultado final do desempenho técnico (na perspectiva das responsabilidades). O CDS, assim como suas categorias, é apresentado também por meio do velocímetro e da tabela. "
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v("Importante!")]),
      _c("ul", [
        _c("li", [
          _c("p", { staticClass: "text-start" }, [
            _c(
              "span",
              { staticClass: "font-weight-medium info--text text-lg-h6" },
              [
                _vm._v(
                  " O cálculo do Coeficiente de Desempenho do Servidor (CDS) utiliza a fórmula: "
                ),
              ]
            ),
          ]),
        ]),
        _c("p", { staticClass: "text-center" }, [
          _c(
            "span",
            { staticClass: "font-weight-medium error--text text-lg-h6" },
            [
              _vm._v(
                " (resultado comportamental x resultado de responsabilidades) / 10 "
              ),
            ]
          ),
        ]),
        _c("li", [
          _c(
            "p",
            {
              staticClass:
                "text-start font-weight-medium info--text text-lg-h6",
            },
            [
              _vm._v(
                " Para mais esclarecimentos, consulte os normativos do Programa disponíveis no site: "
              ),
              _c(
                "a",
                {
                  attrs: { href: "http://desenvolva.ufc.br", target: "_blank" },
                },
                [_vm._v(" desenvolva.ufc.br ")]
              ),
            ]
          ),
        ]),
        _c("li", [
          _c("p", { staticClass: "text-start" }, [
            _c(
              "span",
              { staticClass: "font-weight-medium info--text text-lg-h6" },
              [
                _vm._v(
                  " Você pode imprimir todos os resultados na opção baixar PDF "
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }